import NiceModal, { useModal } from '@ebay/nice-modal-react';

import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useDispatch } from 'react-redux';

import Button from 'components/field/Button';
import EnumSelect from 'components/field/EnumSelect';
import StringInput from 'components/field/StringInput';
import FormItem from 'components/form/FormItem';
import LottiePlayer from 'components/global/LottiePlayer';
import Modal from 'components/global/Modal';
import * as S from 'components/global/styled/ConfirmationModal.styled';
import { updateDynamicListsInPage } from 'components/list/dynamicListSlice';

import useAlert from 'hooks/useAlert';
import useAxiosPrivate from 'hooks/useAxiosPrivate';

import { ENUMS, PRICE_CONFIGURATIONS } from 'services/consts';

import { setLoading } from 'stores/layoutSlice';

import AppLogger from 'utils/AppLogger';

const ChargeCorrectionModal = NiceModal.create(
	({ ids, orderNumbers, manuallyChargedCreditCheck, manuallyChargedCredit }) => {
		const { t } = useTranslation();
		const dispatch = useDispatch();
		const modal = useModal();
		const axiosPrivate = useAxiosPrivate();
		const { showSuccess, showError } = useAlert();
		const handleCloseModal = () => {
			modal.remove();
		};
		const [chargeCorrectionReason, setChargeCorrectionReason] = useState(null);

		const onSubmit = async () => {
			dispatch(setLoading(true));

			await axiosPrivate
				.post(PRICE_CONFIGURATIONS.CHARGE_CORRECTION, {
					ids,
					descriptionType: chargeCorrectionReason
				})
				.then((response) => {
					if (response?.status === 200) {
						showSuccess();
					} else {
						AppLogger.error(response);
					}
				})
				.catch((error) => {
					AppLogger.error(error);
					showError();
				})
				.finally(() => {
					dispatch(updateDynamicListsInPage());
				});

			dispatch(setLoading(false));
		};

		return (
			<>
				<Modal maxWidth="x-small" fullwidth closeButton={false} className="modal-confirmation">
					<S.Container>
						<S.IconContainer>
							<LottiePlayer
								name={manuallyChargedCreditCheck ? 'alert-warning-icon' : 'confirmation-modal'}
							/>
						</S.IconContainer>
						<S.HeadText>{t('chargeCorrectionToClient')}</S.HeadText>
						<S.BodyText>
							{manuallyChargedCreditCheck
								? t('chargeCorrectionToClientManuallyBiggerThanZero', {
										manuallyChargedCredit
									})
								: t('chargeCorrectionToClientConfirmation')}
							<FormItem label="otoOrderID" style={{ marginTop: '2rem' }}>
								<StringInput value={orderNumbers.join(', ')} disabled />
							</FormItem>
							<FormItem label="chargeCorrectionReason">
								<EnumSelect
									searchable={false}
									enumName={ENUMS.INVOICE_CHECKER_DIFFERENCE_TYPES}
									setValue={(value) => {
										setChargeCorrectionReason(value);
									}}
									multipleSelection
									value={chargeCorrectionReason}
								/>
							</FormItem>
						</S.BodyText>
						<S.BlockDiv>
							<S.ButtonContainer>
								<Button
									onClick={() => {
										handleCloseModal();
									}}
									label={t('no')}
									variant="outline"
									style={{ minWidth: '70px' }}
								/>
							</S.ButtonContainer>
							<S.ButtonContainer>
								<Button
									onClick={() => {
										handleCloseModal();
										onSubmit();
									}}
									variant="blue"
									style={{ minWidth: '70px' }}
									label={'yes'}
								/>
							</S.ButtonContainer>
						</S.BlockDiv>
					</S.Container>
				</Modal>
			</>
		);
	}
);

export default ChargeCorrectionModal;
